// We will need access to the store here to authenticate routes.
// See this discussion: https://stackoverflow.com/questions/42603909/accessing-vuex-state-when-defining-vue-router-routes

import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard/Dashboard.vue";

import User from "@/pages/User/UserProfile.vue";

import Billing from "@/pages/Organization/Billing.vue";
import Subscription from "@/pages/Organization/Subscription.vue";

import ApplicationListing from "@/pages/Application/ApplicationListing.vue";
import Application from "@/pages/Application/Application";

import Channel from "@/pages/Channel/Channel";

import APIKeys from "@/pages/APIKey/APIKeys.vue";

import Downloads from "@/pages/Clients/Downloads.vue";

import Recordings from "@/pages/Recordings/Recordings.vue";

import Auth0Callback from "@/fmComponents/Auth0Callback";
import Logout from "@/fmComponents/Logout";
import { requireAuth } from "../utils/auth0";

import NotFound from "@/pages/NotFound/NotFound";

import SessionInfo from "@/pages/Session/SessionInfo.vue";
import ConnectionStats from "@/pages/Session/ConnectionStats.vue";
import Error from "@/pages/Error/Error.vue";

const routes = [
  {
    path: "/auth0-callback",
    component: Auth0Callback
  },
  {
    path: "/error",
    component: Error,
  },
  {
    path: "/logout",
    component: Logout
  },
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  {
    path: "/",
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard }
      },
      {
        path: "profile",
        name: "User Profile and Preferences",
        components: { default: User }
      },
      {
        path: "billing",
        name: "Billing & Invoicing",
        components: { default: Billing }
      },
      {
        path: "sessionInfo",
        name: "Session Info",
        components: { default: SessionInfo }
      },
      {
        path: "/connectionstats/:id",
        name: "Connection Statistics",
        component: ConnectionStats,
        props: route => ({
          id: route.params.id,
          appId: route.query.applicationId
        })
      },
      {
        path: "applications",
        name: "Applications",
        components: { default: ApplicationListing }
      },
      {
        path: "/application/:id",
        name: "Application Settings",
        component: Application,
        props: true
      },
      {
        path: "/application/:appId/channel/:id",
        name: "Channel Config",
        component: Channel,
        props: true
      },
      {
        path: "apikeys",
        name: "API Keys",
        components: { default: APIKeys }
      },
      {
        path: "subscription",
        name: "Subscription",
        components: { default: Subscription }
      },
      {
        path: "downloads",
        name: "Downloads",
        components: { default: Downloads }
      },
      {
        path: "recordings",
        name: "Recordings",
        components: { default: Recordings }
      },
      { path: "/404", component: NotFound },
      { path: "*", redirect: "/404" }
    ]
  }
];

export default routes;
